<!-- header -->
<router-outlet name="header"></router-outlet>

<!-- content -->

<mat-card-title class="imc--molla-pa">
  <tel-breadcrumb></tel-breadcrumb>
</mat-card-title>

<mat-card-content class="imc--contingut">
  <router-outlet></router-outlet>
</mat-card-content>

<!-- footer -->
<router-outlet name="footer"></router-outlet>
